import { css } from 'styled-components';

export default css`
  
  label {
    margin-right: 10px;
    cursor: pointer;
  }
`;
